import React from 'react';

import workExperience from '../data/work-experience';
import Experience from '../components/work/Experience'

class Work extends React.Component {

    render(data){
        return (
            <div>
                <h2>Work</h2>
                <p>Here are the places i worked and things ive done</p>

                {workExperience.map((job) =>
                    <Experience data={job}/>)}
            </div>
        )
    }
}

export default Work;